import React from 'react';
import InputV2 from '../InputV2';

const options = {
  'NOT_SYNC': 'Não sincronizado',
  'SYNC_TO_APP': 'Sincronizado para o app',
  'SYNC_FROM_APP': 'Sincronizado do app',
}

const NsirSyncStatusSelectV2 = ({ value }) => {
  return (
    <InputV2
      label="Status Sincronização"
      value={value ? options[value] : ""}
      disabled
    />
  );
}

export default NsirSyncStatusSelectV2;
